export default function Modal_image(props) {
  // const [modalIsOpen, setIsOpen] = useState(false);

  function closeModal() {
    props.setIsOpen(false);
  }

  let keepPlayClass = "keep_playing";

  return (
    <div className="answer-image">
        <h2 className="answer-image-title">Μπράβο! Αυτή είναι η σωστή απάντηση</h2>
          <button
            className={keepPlayClass}
            onClick={() => {
              //handleOnChange();
              props.scount(props.mycount + 1);
              closeModal();
            }}
          > 
        <span className="button-text">Συνέχισε</span>
      </button>
        <img src={`/games/wizard/img/${props.finalImage}`} alt={props.finalImageAlt} loading="lazy" />
      <p className="answer-image-description">{ props.textCorrectAnswer }</p>
    </div>
  );
}
